import {
  cancelVehicleCert,
  VehicleCert
} from '../../services/endpoints/service29'
import { Button } from 'reactstrap'

type Props = {
  cert: VehicleCert
  confirmationMessage?: string
  onSuccess: () => void
  onError: () => void
}

export const Service29CancelButton = ({
  cert,
  confirmationMessage = 'Are you sure you want to cancel the pending vehicle cert?',
  onSuccess,
  onError
}: Props) => {
  const handleClick = async () => {
    if (!window.confirm(confirmationMessage)) return
    try {
      await cancelVehicleCert(cert)
      onSuccess()
    } catch {
      onError()
    }
  }

  return (
    <Button
      style={{ padding: '0.25rem 1rem' }}
      color="danger"
      outline={true}
      aria-label="Cancel pending certificate"
      onClick={handleClick}
    >
      <span
        style={{ margin: 0, height: 'auto', fontSize: '1rem' }}
        className="glyphicons glyphicons-remove-circle"
      ></span>
    </Button>
  )
}
